import React from 'react'
import { useProjectContext } from '../../context/ProjectContext'
import './Toolbar.css'

const BrushSize = () => {
  const { brushSize, setBrushSize } = useProjectContext()

  return (
    <div className="brush-size">
      <span className="brush-size__label ui-control">Brush</span>

      {[1, 2, 3].map((n) => (
        <button
          key={n}
          type="button"
          className={
            brushSize === n
              ? 'brush-size__btn ui-control active'
              : 'brush-size__btn ui-control'
          }
          onClick={() => setBrushSize(n)}
        >
          {n}×{n}
        </button>
      ))}
    </div>
  )
}

export default BrushSize